import * as t from "io-ts";
export const AccumulatedFundingIO = t.type({
  fundedAmount: t.number,
  fundingRounds: t.number,
  mostFundedStage: t.string,
  companyCount: t.number
});
export type AccumulatedFundingT = t.TypeOf<typeof AccumulatedFundingIO>;

export const FundingTrendIO = t.type({
  totalAmount: t.number,
  month: t.number,
  year: t.number,
  monthLabel: t.string
});
export const FundingTrendsIO = t.array(FundingTrendIO);
export type FundingTrendT = t.TypeOf<typeof FundingTrendIO>;
